import PropTypes from 'prop-types';

export const dataItemShape = PropTypes.shape({
  previousYearTotalLoanAmount: PropTypes.number.isRequired,
  monthlyTotalLoanAmount: PropTypes.number.isRequired,
  key: PropTypes.string.isRequired,
});

export const dataShape = PropTypes.arrayOf(dataItemShape);
